import { BaseEntity, CommonService } from "yt-ng-framework";

export class CompanyZrc extends BaseEntity{
    constructor(){
        super();
    }

    FirmaID: number = null;
    Zrc1:string = null;
    Zrc2:string = null;
    Zrc3:string = null;
    Zrc:string = null;
    Glavni:boolean = null;
    Devizni:boolean = null;
    BankaID:number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.FirmaID = input.FirmaID;
        this.Zrc1=input.Zrc1;
        this.Zrc2=new CommonService().PadLeft(input.Zrc2, "0", 13);
        this.Zrc3=new CommonService().PadLeft(input.Zrc3, "0", 2);
        this.Zrc = this.Zrc1 +'-'+ this.Zrc2 +'-'+ this.Zrc3;
        this.Glavni=input.Glavni;
        this.Devizni=input.Devizni;
        this.BankaID=input.BankaID;
        return this;
    }

    Serialize(input:CompanyZrc){
        input.Zrc=input.Zrc.replace(/-/g,"");
        input.Zrc1=input.Zrc.substr(0,3).trim();
        input.Zrc2=input.Zrc.substr(3,input.Zrc.length-5).trim();
        input.Zrc3=input.Zrc.substr(input.Zrc.length-2,2).trim();
        return input;
    }
}